import { POPUP_KEY_CREATE_FORM, PRODUCT_CATEGORY_ANY, PRODUCT_FORM_LIQUID } from "../constant";
import i18n from "../i18nService";
import { formsService } from "./formsService";
import { formsStorage } from "./formsStorage";
import { productSaveService } from "./productSaveService";

export const filterFormsList = (form) => {
    const productCategory = productSaveService.getProduct().productCategory;
    return (productCategory && form.formGroup === productCategory)
        || form.formGroup === PRODUCT_CATEGORY_ANY
        || form.formGroup === PRODUCT_FORM_LIQUID
        || productCategory === null;
};

const transformFormsList = (formsList, withFilter, i18nInstance = i18n) => {
    let resultArray = [];
    withFilter ? formsList = formsList.filter(it => filterFormsList(it)) : null;
    formsList.forEach(it => resultArray.push({
        itemId: it.id,
        itemTitle: formsService.getLocalization(i18nInstance.resolvedLanguage, it, true, i18nInstance),
        included: true,
    }));
    return resultArray;
};

export const formsProductService = {
    observersList: [],
    possibleForms: transformFormsList(formsStorage.getItems(true), true),
    selectedForms: [],
    filter: '',
    notifyItemsChangingObservers() {
        this.observersList.forEach(observer => observer());
    },
    getPossibleItems(i18nInstance = i18n) {
        this.possibleForms = transformFormsList(formsStorage.getItems(true)
            .filter(it => formsService.getLocalization(i18nInstance.resolvedLanguage, it, true, i18nInstance).toLowerCase().includes(this.filter)), true, i18nInstance);
        return this.possibleForms;
    },
    getCurrentItems() {
        this.selectedForms = transformFormsList(productSaveService.getProduct().productForms, false);
        return this.selectedForms;
    },
    getPlaceHolder() {
        return "";
    },
    deleteItem(formId) {
        productSaveService.deleteProductForm(formId);
        this.notifyItemsChangingObservers();
    },
    addItem(formId) {
        productSaveService.addProductForm(formId);
        this.notifyItemsChangingObservers();
    },
    registerItemsChangingObserver(observer) {
        this.observersList.push(observer);
    },
    unRegisterItemsChangingObserver(observer) {
        try {
            this.observersList = this.observersList.filter(observerItem => observerItem !== observer);
        } catch (err) {
            console.log(err);
        }
    },
    hasExcludedItemsBlock() {
        return false;
    },
    setSearchFilterValue(searchValue) {
        this.filter = searchValue;
        this.getPossibleItems();
        this.notifyItemsChangingObservers();
    },
    getSearchString() {
        return this.filter;
    },
    isSearchStringChanged() {
        return true;
    },
    handleSearchFilterValue() {},
    getPopupKey() {
        return POPUP_KEY_CREATE_FORM;
    },
    getButtonTitle(i18nInstance = i18n) {
        return i18nInstance.t("app.page.product.addForm");
    },
    getLabelName(i18nInstance = i18n) {
        return i18nInstance.t('app.page.product.productFormName');
    },
};
